module.exports = __webpack_public_path__ + "img/tv-fill.833e659e.svg";